<template>
  <confirm
    name="locationPickerModal"
    v-show="isShow"
    @confirm="handleConfirm"
    :data="dialogData"
  >
    <div class="location-picker-modal box">
      <div class="upload-box">
        <div class="col-12 d-flex flex-column p-0">
          <div class="mb-3">
            <div class="input-group" v-if="canEdit">
              <div class="input-group-prepend">
                <span class="input-group-text">
                  <i class="fas fa-search"></i>
                </span>
              </div>
              <gmap-autocomplete
                class="form-control"
                placeholder="ระบุสถานที่ หรือตำแหน่งที่คุณต้องการ"
                @place_changed="setPlace"
                v-model="searchMap"
              ></gmap-autocomplete>
              <div class="input-group-append">
                <span
                  class="input-group-text"
                  id="clear-map"
                  @click="removeMarker"
                >
                  <i class="fas fa-times-circle"></i>
                </span>
              </div>
            </div>
            <div v-else>
              {{ this.searchMap || "ไม่ระบุ" }}
            </div>
          </div>
          <Gmap-Map
            style="width: 100%; height: 400px"
            :zoom="13"
            :center="center"
            @click="clickedMap"
          >
            <GmapMarker
              v-if="marker"
              :position="marker"
              @click="removeMarker()"
            />
          </Gmap-Map>
        </div>
      </div>
    </div>
  </confirm>
</template>

<script>
import { isEmpty, isNil } from "ramda";

export default {
  props: [
    "title",
    "locationName",
    "latitude",
    "longitude",
    "isShow",
    "isLoading",
    "canEdit"
  ],
  data() {
    return {
      marker: {
        lat: this.latitude,
        lng: this.longitude
      },
      center: this.getDefaultLocation(),
      searchMap: this.locationName,
      location: {
        name: this.locationName,
        latitude: this.latitude,
        longtitude: this.longitude
      }
    };
  },
  watch: {
    isShow(value) {
      if (!value) {
        this.resetSelectLocation();
      }
    }
  },
  computed: {
    dialogData() {
      const buttonSubmit = this.isLoading ? "กำลังดำเนินการ" : "เลือก";

      return {
        title: this.title,
        buttonCancel: "ยกเลิก",
        buttonSubmit,
        disableSubmit: this.isLoading,
        disableCancel: this.isLoading
      };
    }
  },
  methods: {
    async handleConfirm(isConfirm) {
      if (!isConfirm) {
        this.$emit("cancel");
        return;
      }

      this.$emit("confirm", this.location);
    },
    clickedMap(e) {
      if (this.canEdit) {
        this.marker = e.latLng;
        this.getLocationName(e.latLng.lat(), e.latLng.lng());
      }
    },
    getLocationName(lat, lng) {
      /* global google */
      const geocoder = new google.maps.Geocoder();

      geocoder.geocode({ location: this.marker }, (results, status) => {
        if (status === "OK") {
          this.searchMap = results[0].formatted_address;
          this.location = {
            name: results[0].formatted_address,
            latitude: lat,
            longitude: lng
          }
        }
      });
    },
    setPlace(place) {
      this.marker = place.geometry.location;
      this.center = place.geometry.location;
      this.location = {
        name: place.name,
        latitude: place.geometry.location.lat(),
        longitude: place.geometry.location.lng()
      }
    },
    removeMarker() {
      this.marker = null;
      this.searchMap = "";
      this.location = {
        name: "",
        latitude: 0,
        longitude: 0
      };
    },
    getDefaultLocation() {
      if (this.latitude && this.longitude) {
        return {
          lat: Number.parseFloat(this.latitude),
          lng: Number.parseFloat(this.longitude)
        };
      }

      return { lat: 13.8232912, lng: 100.55719 };
    },
    resetSelectLocation() {
      this.marker = {
        lat: this.latitude,
        lng: this.longitude
      };
      this.center = this.getDefaultLocation();
      this.searchMap = this.locationName;
      this.location = {
        name: this.locationName,
        latitude: this.latitude,
        longitude: this.longitude
      };
    }
  }
};
</script>

<style lang="scss">
.location-picker-modal {
   > .upload-box {
    position: relative;

    font-size: 14px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.21;
    letter-spacing: normal;
    text-align: center;
    color: #8c8786;
    object-fit: thumbnail;

    margin: 0 auto;
    width: 700px;
    height: 450px;
  }
}
</style>



// WEBPACK FOOTER //
// src/lib/components/LocationPickerModal.vue